<template>
    <div class="MainInfo">
        <div class="MainInfo-main" id="MainInfo-main-id" @click="MainInfoAkakuwab">
            <i class="fas fa-globe MainInfoIcone"></i>
            <span class="ContadorAlarme"><center>{{ qtasMsgMainInfo }}</center></span>
        </div>

        <div id="MainInfo-conteudo" class="MainInfo-akakuwab">
            <div id="MainInfo-conteudo-akanga-id" class="MainInfo-conteudo-akanga" >
                <div class="MainInfo-akanga-ab">Alertas - Plataforma Hion</div>
            </div>
            <div class="MainInfo-conteudo-kwatiar">
                <div v-if="!haMsg">
                    <b-img-lazy 
                        :src="require('../../assets/okSemAlarme.jpg')"
                        alt="Sem alertas no momento" 
                        class="MainInfo-conteudo-aaniAsem"
                        id="MainInfo-conteudo-aaniAsem-id">
                    </b-img-lazy>
                    <div class="MainInfo-conteudo-kwatiar-info text-center">Não há nenhum alerta no momento!</div>
                </div>
                <div v-else>
                    <Notificacoes v-for="notificacoes in notificacoesPorPag" 
                        :key="notificacoes.id"
                        :notificacaoObj="notificacoes" 
                        v-on:apaga="apagaMainInfo"
                        v-on:lida="lidaMainInfo"
                        class="mainInfo-notificacoes" 
                    />
                    <b-pagination 
                        class="MainInfo-conteudo-kwatiar-pag"
                        v-model="currentPage" 
                        pills 
                        :total-rows="qtasMsgMainInfo" 
                        :per-page="perPage"
                        size="sm"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainInfo',
    components: {
        Notificacoes: () => import(/* webpackChunkName: "mainInfoNotificacao" */ "./notificacao"),
    },
    props: { },
    computed: {
        qtasMsgMainInfo: function () {
            return this.notificacoesObjeto.length
        },
        notificacoesPorPag() {
            const items = this.notificacoesObjeto;
            // Return somente as páginas necessárias de acordo com a paginação 
            return items.slice(
                (this.currentPage - 1) * this.perPage,
                this.currentPage * this.perPage
            )
        }
    },
    data: function() {
        return {
            akakuwabMainInfo: false,
            clicouNosBotMainInfo: false,
            haMsg: false,
            perPage: 5,
            currentPage: 1,
            notificacoesObjeto: [
                {
                    id: '1-inf',
                    descricao: 'Atualizacao de Software',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Informativa',
                    icone: 'fas fa-cloud-upload-alt',
                    cor: '#008fac',
                    datahora: '2020-01-12T04:20:20Z'
                },
                {
                    id: '2-inf',
                    descricao: 'Aprimore suas Metas',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Informativa',
                    icone: 'fas fa-brain',
                    cor: 'orange',
                    datahora: '2020-07-07T16:20:20Z'
                },
                {
                    id: '3-inf',
                    descricao: 'Mensalidade em Atraso',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Importante',
                    icone: 'fas fa-money-check-alt',
                    cor: 'red',
                    datahora: '2020-07-05T16:20:20Z'
                },
                {
                    id: '4-inf',
                    descricao: 'Economize ainda mais',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Informativa',
                    icone: 'fas fa-hand-holding-usd',
                    cor: '#00AB66',
                    datahora: '2020-07-05T04:20:31Z'
                },
                {
                    id: '5-inf',
                    descricao: 'Meta Atingida',
                    codigo: 'C-137',
                    apelido: 'Kinder DEV',
                    tipo: 'Informativa',
                    icone: 'fas fa-trophy',
                    cor: 'gold',
                    datahora: '2020-07-12T04:15:31Z'
                },
            ]
        }
    },
    watch: {
        notificacoesObjeto: function () {
            if(this.notificacoesObjeto.length > 0) this.haMsg = true;
                else this.haMsg = false;
        }
    },
    methods: {
        MainInfoAkakuwab() {
            this.akakuwabMainInfo = !this.akakuwabMainInfo;

            if (this.akakuwabMainInfo) {
                const alvo = document.getElementById("MainInfo-conteudo");
                alvo.classList.add("MainInfo-akakuwab-esa");
                window.addEventListener('click', this.fecharMainInfoAkakuwab);
            } else {
                const alvo = document.getElementById("MainInfo-conteudo");
                alvo.classList.remove("MainInfo-akakuwab-esa");
                window.removeEventListener('click', this.fecharMainInfoAkakuwab);
            }
        },
        fecharMainInfoAkakuwab() {
            const alvo = document.getElementById("MainInfo-conteudo");
            const botao = document.getElementById('MainInfo-main-id');
            const cardNotificacao = document.getElementById('notificacao-id');

            const ClickDentro = alvo.contains(event.target);
            const ClickBotao = botao.contains(event.target);
            let ClickNotifica = false;
            if(cardNotificacao !== null) ClickNotifica = cardNotificacao.contains(event.target);

            if(event.target.classList.value !== 'page-link') {  //Executa se não clicou no botao da paginação
                if(!ClickBotao)   {  //so executa de clicou fora do botao
                    if(!ClickNotifica) { //So executa se clicou fora de alguma notificacao
                        if(!ClickDentro) {
                            //Se clicou fora efetua o fechamento do menu avatar
                            if(!this.clicouNosBotMainInfo) {
                                this.$emit('fechouJanela');
                                alvo.classList.remove("MainInfo-akakuwab-esa");
                                this.akakuwabMainInfo = false;
                                this.currentPage = 1;
                                window.removeEventListener('click', this.fecharMainInfoAkakuwab);
                            } else {
                                this.clicouNosBotMainInfo = false;
                            }
                        }
                    }
                }
            }
        },
        apagaMainInfo(reqID) {
            this.clicouNosBotMainInfo = true;
            const pos = this.notificacoesObjeto.map(function(e) { return e.id; }).indexOf(reqID);
            this.notificacoesObjeto.splice(pos, 1);
            //Falta implementar as ações com o servidor
        },
        lidaMainInfo(reqID) {
            this.clicouNosBotMainInfo = true;
            const pos = this.notificacoesObjeto.map(function(e) { return e.id; }).indexOf(reqID);
            this.notificacoesObjeto.splice(pos, 1);
            //Falta implementar as ações com o servidor
        },
        initMainInfo(entrada) {
             if(entrada.length > 0) this.haMsg = true;
        }
    },
    mounted() {
        this.initMainInfo(this.notificacoesObjeto);
    }
}
</script>

<style>
.MainInfo {
    position: relative;
    height: 50px;
    width: 50px;
}
.MainInfo-main {
    height: 50px;
    width: 50px;
}
.MainInfo:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
}
.MainInfoIcone {
    position: absolute;
    top: 13px;
    left: 5px;
    font-size:  25px;
    color: #008fac;
}
.ContadorAlarme {
    position: absolute;
    top: 3px;
    left: 15px;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    color: #000;
    background: #ffd618;
    width: 32px;
    border-radius: 20px;
}

/********************************************************************************* */
/* Tela Expansiva de alertas *******************************************************/
.MainInfo-akakuwab {
    position: absolute;
    right: -45px;
    top: 52px;
    background-color: #fff;
    min-width: 290px;
    min-height: 400px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 6;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: hidden;
    text-align: left !important;

    visibility: hidden;
    opacity: 0;
    transition: visibility 0.5s, opacity 0.5s linear;
}

.MainInfo-akakuwab-esa {
    visibility: visible;
    opacity: 1;
}
/* ***************************************************************/

/* Ajuste do componente de Notificacoes **************************/
.mainInfo-notificacoes {
    height: 50px;
    width: 100%;
}
/*****************************************************************/

/* Conteudo do cabeçalho do menu **********************************/
.MainInfo-conteudo-akanga {
    background-image: url("../../assets/hion_18.png");
    background-color: #000;
    /*background-image: linear-gradient(to bottom right, #008fac , #004f5f);*/

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    /* Needed to position the navbar */
    position: relative;
    height: 100px;
    width: 290px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.MainInfo-akanga-ab {
    text-decoration: none;
    position: absolute;
    top: 35px;
    left: 30px;
    color: #fff;
    text-shadow: 0px 2px 2px #000000;
    font-family: "Play", sans-serif;
    font-size: 20px;
}
.MainInfo-conteudo-kwatiar {
    position: relative;
    height: 300px;
    width: 290px;
}
.MainInfo-conteudo-aaniAsem {
    height: 260px;
    width: 100%;
}
.MainInfo-conteudo-kwatiar-info {
    text-decoration: none;
    color: #2e2d2c;
    font-family: "Play", sans-serif;
    font-size: 16px;
}
.MainInfo-conteudo-kwatiar-pag {
    position: absolute;
    top: calc(100% - 25px);
    left: 50%;
    transform: translate(-50%, -50%);
}

/********************************************************************* */

/* MEDIA QUERY XS ******************************************************/
@media (max-width:575px) {
    .MainInfo-akakuwab {
        right: -95px;
    }
}

</style>